import React from "react";

// const flower = new URL("../assets/images/flower1.svg", import.meta.url);

export default function ListItem({ number, image, title, desc }) {
  return (
    <div className="flex flex-col items-center">
      <div className="rounded-full bg-white w-[80px] h-[80px] p-10 flex items-center justify-center mb-4 text-[32px] font-intermedium relative">
        {image}
        {number}
      </div>
      <div className="font-intermedium text-[24px] mb-2">{title}</div>
      <div className="text-center font-interlight text-[18px]">{desc}</div>
    </div>
  );
}
